import { TextInput } from '@mantine/core';
import React, { useState } from 'react';
import './styles.scss';

interface CurrencyInputProps {
  value: number; // value in cents
  currencySymbol?: string;
  showSymbol?: boolean; // show symbol when not editing
  onChange: (value: number) => void;
  onFinish?: () => void;
  label?: string;
  disabled?: boolean;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  currencySymbol = '€',
  showSymbol = true,
  onChange,
  onFinish,
  disabled,
  label
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState('');

  // Format for display (only when not editing)
  const formattedValue = !isEditing
    ? (value / 100).toFixed(2).replace('.', ',') + (showSymbol ? ` ${currencySymbol}` : '')
    : inputValue;

  const toCents = (v: string) => {
    const parsed = parseFloat(v.replace(',', '.'));
    return isNaN(parsed) ? 0 : Math.round(parsed * 100);
  };

  const handleFocus = () => {
    setIsEditing(true);
    setInputValue((value / 100).toFixed(2).replace('.', ','));
  };

  const handleBlur = () => {
    const cents = toCents(inputValue);
    onChange(cents);
    setIsEditing(false);
    onFinish?.();
  };

  return (
    <TextInput
      label={label}
      value={formattedValue}
      disabled={disabled}
      onFocus={handleFocus}
      onChange={e => setInputValue(e.currentTarget.value)}
      onBlur={handleBlur}
      style={{ cursor: 'pointer' }}
      className="currency-input"
    />
  );
};

export default CurrencyInput;
